// @ts-nocheck
/**
 * Utilitário para manter o Service Worker ativo no iOS
 * quando o app está fechado
 */

let keepAliveInterval: number | null = null;
let messageChannel: MessageChannel | null = null;

export const startServiceWorkerKeepAlive = () => {
  if (!('serviceWorker' in navigator)) {
    console.warn('[KeepAlive] Service Worker não suportado');
    return;
  }

  // Limpar intervalo anterior se existir
  if (keepAliveInterval) {
    clearInterval(keepAliveInterval);
  }

  // Criar canal de mensagens
  messageChannel = new MessageChannel();

  // Enviar ping a cada 25 segundos para manter SW ativo
  // iOS pode "dormir" o SW após ~30s sem atividade
  keepAliveInterval = window.setInterval(async () => {
    try {
      const registration = await navigator.serviceWorker.ready;
      
      if (registration.active) {
        // Criar novo canal para cada mensagem
        const channel = new MessageChannel();
        
        // Enviar mensagem de keep-alive
        registration.active.postMessage(
          { type: 'KEEP_ALIVE', timestamp: Date.now() },
          [channel.port2]
        );
        
        // Fazer uma requisição fetch simples para manter conexão ativa
        try {
          await fetch('/mobile', { 
            method: 'HEAD', 
            cache: 'no-cache',
            keepalive: true 
          });
        } catch (fetchError) {
          // Ignorar erros de fetch (pode estar offline)
        }
        
        // Tentar registrar background sync se disponível (não funciona no iOS, mas não causa erro)
        if ('sync' in registration) {
          try {
            await registration.sync.register('keep-alive-sync');
          } catch (error) {
            // Ignorar se já estiver registrado ou não suportado
          }
        }
        
        console.log('[KeepAlive] ✅ Ping enviado ao Service Worker');
      } else {
        // Se SW não estiver ativo, tentar reativar
        console.warn('[KeepAlive] ⚠️ Service Worker não está ativo, tentando reativar...');
        try {
          await navigator.serviceWorker.register('/mobile-sw.js');
        } catch (error) {
          console.error('[KeepAlive] Erro ao reativar SW:', error);
        }
      }
    } catch (error) {
      console.warn('[KeepAlive] Erro ao enviar ping:', error);
    }
  }, 25000); // 25 segundos (antes dos 30s do iOS)

  console.log('[KeepAlive] ✅ Keep-alive iniciado');
};

export const stopServiceWorkerKeepAlive = () => {
  if (keepAliveInterval) {
    clearInterval(keepAliveInterval);
    keepAliveInterval = null;
    console.log('[KeepAlive] ⏹️ Keep-alive parado');
  }
};

// Iniciar automaticamente quando o módulo for carregado
if (typeof window !== 'undefined') {
  // Aguardar service worker estar pronto
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(() => {
      startServiceWorkerKeepAlive();
    });
  }
}

